export default "__VITE_ASSET__BuPt0ifF__"